import _toConsumableArray from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/classCallCheck";

function e(_ref) {
  var e = _ref.node,
      _ref$child = _ref.child,
      t = _ref$child === void 0 ? [] : _ref$child,
      _ref$from = _ref.from,
      n = _ref$from === void 0 ? [] : _ref$from,
      _ref$scope = _ref.scope,
      r = _ref$scope === void 0 ? {} : _ref$scope,
      _ref$meta = _ref.meta,
      o = _ref$meta === void 0 ? {} : _ref$meta;
  return {
    from: n.map(X),
    seq: e,
    next: t.map(X),
    meta: o,
    scope: r
  };
}

function t(e) {
  return e.compositeName ? e.compositeName.fullName : e.domainName ? e.domainName.fullName : e.id;
}

function n(e) {
  var n = 0;
  var r = Object.values(e),
      o = Fe - 1,
      a = r.length - 1;
  var i = 'combine(';

  for (var _i = 0, _r = r; _i < _r.length; _i++) {
    var _e2 = _r[_i];

    var _r2 = n === o || a === n ? '' : ', ';

    if (Ie(_e2) || qe(_e2) || Ce(_e2) ? i += t(_e2) + _r2 : i += _e2.toString() + _r2, n += 1, '' === _r2) break;
  }

  return i + ')';
}

function r(e, t, n) {
  this.shortName = e, this.fullName = t, this.path = n;
}

function o(e, t) {
  var n, o;
  var a = e;
  return void 0 === t ? (n = 0 === e.length ? [] : [e], o = e) : 0 === e.length ? (n = t.path, o = t.fullName) : (n = t.path.concat([e]), o = 0 === t.fullName.length ? e : t.fullName + '/' + e), new r(a, o, n);
}

function a(e) {
  return e(this);
}

function i() {
  var e = this.indexOf();
  -1 !== e && (this.splice(e, 1), this.indexOf = He, this.splice = Me);
}

function s(_ref2) {
  var n = _ref2.name,
      r = _ref2.parent,
      _ref2$config = _ref2.config,
      i = _ref2$config === void 0 ? {} : _ref2$config;

  var c = Be(),
      l = n || c,
      u = o(l, r),
      f = u.fullName,
      d = e({
    node: [L.emit({
      fullName: f
    })]
  }),
      p = function p(e) {
    for (var _len = arguments.length, t = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      t[_key - 1] = arguments[_key];
    }

    return p.create(e, f, t);
  };

  return p.getType = function () {
    return f;
  }, p.create = function (e) {
    return ge(p, e), e;
  }, p.kind = P, p[T] = function () {
    return p;
  }, p.id = c, p.watch = function (e, n) {
    return Re(e, {
      scope: {
        trigger: e,
        handler: n
      },
      node: [we, L.run({
        fn: function fn(e, _ref3) {
          var n = _ref3.trigger,
              r = _ref3.handler;
          return r(e, t(n));
        }
      })]
    });
  }.bind(null, p), p.map = function (e, t) {
    var n = s({
      name: e.shortName + ' → *',
      parent: e.domainName
    });
    return Re(e, {
      child: [n],
      scope: {
        handler: t
      },
      node: [L.compute({
        fn: function fn(e, _ref4) {
          var t = _ref4.handler;
          return t(e);
        }
      })]
    }), n;
  }.bind(null, p), p.filter = function (e, t) {
    var n = s({
      name: e.shortName + ' →? *',
      parent: e.domainName
    });
    return Re(e, {
      scope: {
        handler: t
      },
      child: [n],
      node: [L.compute({
        fn: function fn(e, _ref5) {
          var t = _ref5.handler;
          return t(e);
        }
      }), L.filter({
        fn: function fn(e, t) {
          return t.val = e, void 0 !== e;
        }
      }), L.compute({
        fn: function fn(e, t) {
          return t.val;
        }
      })]
    }), n;
  }.bind(null, p), p.prepend = function (e, t) {
    var n = s({
      name: '* → ' + e.shortName,
      parent: e.domainName
    });
    return Re(n, {
      child: [e],
      scope: {
        handler: t
      },
      node: [L.compute({
        fn: function fn(e, _ref6) {
          var t = _ref6.handler;
          return t(e);
        }
      })]
    }), n;
  }.bind(null, p), p.subscribe = function (e, t) {
    return e.watch(function (e) {
      return t.next(e);
    });
  }.bind(null, p), p.thru = a.bind(p), p.graphite = d, p.shortName = l, p.domainName = r, p.compositeName = u, p.defaultConfig = i, p;
}

function c() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var t = 'createStore: Second argument should be plain object, but you passed %s.';
  xe('object' == typeof e && null !== e, t, e), void 0 !== (null == e ? void 0 : e.ɔ) && xe('object' == typeof e.ɔ && null !== e.ɔ, t, e.ɔ);
  var n = Object.assign({}, e, 'object' == typeof e.ɔ ? e.ɔ : {});
  return delete n.ɔ, n;
}

function l(e, t) {
  var n = 'object' == typeof e ? Object.assign({}, c(t), e) : c(t);
  return {
    config: n,
    name: 'object' == typeof e || void 0 === e ? n.name : e
  };
}

function u(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _l = l(e, t),
      n = _l.config,
      r = _l.name;

  return s({
    name: r,
    config: n
  });
}

function f(e) {
  z('function' == typeof e || 'object' == typeof e && null !== e, 'expect observable to be object or function');
  var t = T in e ? e[T]() : e;
  z('subscribe' in t, 'expect observable to have .subscribe');
  var n = u(),
      r = Q.bind(null, n, {});
  return t.subscribe({
    next: n,
    error: r,
    complete: r
  }), n;
}

function d() {}

function p() {}

function m(e) {
  return $(e.plainState);
}

function h(e, t) {
  var n = e.subscribers.get(t);
  void 0 !== n && (n(), e.subscribers.delete(t));
}

function b(e, n, r) {
  var o = n,
      a = e.subscribers.get(o);
  return a && a(), e.subscribers.set(o, Re(o, {
    scope: {
      handler: r,
      state: e.plainState,
      trigger: o
    },
    child: [e],
    node: [L.compute({
      fn: function fn(e, _ref7) {
        var n = _ref7.handler,
            r = _ref7.state,
            o = _ref7.trigger;
        var a = n($(r), e, t(o));
        if (void 0 !== a) return ee(r, a);
      }
    })]
  })), this;
}

function g(e, n, r) {
  var o = 'watch requires function handler';

  switch (r && (null == n ? void 0 : n.kind)) {
    case 'store':
    case 'event':
    case 'effect':
      return z('function' == typeof r, o), n.watch(function (o) {
        return r(m(e), o, t(n));
      });

    default:
      return z('function' == typeof n, o), v(e, n);
  }
}

function v(e, t) {
  z('function' == typeof t, 'Expected the listener to be a function');
  var n = 'Got initial error',
      r = m(e);
  d(e, 'subscribe');

  try {
    t(r), n = 'Initial';
  } catch (e) {
    console.error(e);
  }

  return p(n), Re(e, {
    node: [we, L.run({
      fn: function fn(n) {
        var o = null;

        if (d(e, 'subscribe'), n !== r) {
          r = n;

          try {
            t(n);
          } catch (e) {
            console.error(e), o = 'Got error';
          }

          p(o);
        } else p(o);
      }
    })]
  });
}

function y(t) {
  var n = t.currentState,
      r = t.config,
      i = t.parent,
      s = r.name,
      c = Z(n),
      l = s || c.id,
      f = n,
      N = o(l, i),
      S = u('update ' + l),
      w = {
    graphite: e({
      scope: {
        state: c,
        oldState: n
      },
      node: [L.filter({
        fn: function fn(e) {
          return void 0 !== e;
        }
      }), L.update({
        store: c
      }), L.filter({
        fn: function fn(e, t) {
          return e === t.oldState ? 0 : (t.oldState = e, 1);
        }
      })]
    }),
    kind: A,
    id: c.id,
    shortName: l,
    domainName: i,
    defaultConfig: r,
    defaultState: f,
    plainState: c,
    subscribers: new Map(),
    compositeName: N
  },
      k = {
    compositeName: w.compositeName,
    graphite: w.graphite,
    kind: A,
    id: c.id,
    shortName: l,
    domainName: i,
    setState: function setState(e, t) {
      var n = m(w),
          r = 'function' == typeof t ? t(n, e) : e;
      ge(k, r);
    },
    off: h.bind(null, w),
    watch: g.bind(null, w),
    updates: S,
    subscribe: v.bind(null, w),
    getState: m.bind(null, w),
    stateRef: c
  };
  return k.defaultConfig = r, k.reset = function (e) {
    for (var _len2 = arguments.length, t = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      t[_key2 - 1] = arguments[_key2];
    }

    for (var _i2 = 0, _t = t; _i2 < _t.length; _i2++) {
      var _n = _t[_i2];
      b.call(this, e, _n, function () {
        return e.defaultState;
      });
    }

    return this;
  }.bind(k, w), k.on = b.bind(k, w), k.defaultState = f, k.map = function (e, t, n) {
    var r;
    d(e, 'map');
    var o = 'Got initial error';

    try {
      var _a = e.getState();

      void 0 !== _a && (r = t(_a, n)), o = 'Initial';
    } catch (e) {
      console.error(e);
    }

    p(o);
    var a = this({
      config: {
        name: e.shortName + ' → *'
      },
      currentState: r,
      parent: e.domainName
    });
    return Re(e, {
      child: [a],
      scope: {
        store: e,
        handler: t,
        state: a.stateRef
      },
      node: [L.compute({
        fn: function fn(e, _ref8) {
          var t = _ref8.state,
              n = _ref8.store,
              r = _ref8.handler;
          d(n, 'map');
          var o,
              a = 'Got error';

          try {
            o = r(e, $(t)), a = null;
          } catch (e) {
            console.error(e);
          }

          return p(a), o;
        }
      }), Se]
    }), a;
  }.bind(y, k), k.thru = a.bind(k), k.dispatch = function (e) {
    return e;
  }.bind(null), k[T] = function (e) {
    var t = {
      subscribe: function subscribe(t) {
        return z('object' == typeof t && null !== t, 'Expected the observer to be an object.'), v(e, function (e) {
          t.next && t.next(e);
        });
      }
    };
    return t[T] = function () {
      return this;
    }, t;
  }.bind(null, w), Te({
    from: k,
    to: S
  }), k;
}

function N(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return z(void 0 !== e, "createStore: First argument can't be undefined, use null instead."), y({
    currentState: e,
    config: c(t)
  });
}

function S(e, t) {
  var n = o(t, e.domainName);
  e.shortName = t, e.compositeName ? (e.compositeName.path = n.path, e.compositeName.shortName = n.shortName, e.compositeName.fullName = n.fullName) : e.compositeName = n;
}

function w(e, t) {
  var n = Array.isArray(e) ? We(e, function (e) {
    return e.slice();
  }, []) : We(e, function (e) {
    return Object.assign({}, e);
  }, {});
  return t ? n.map(t) : n;
}

function k(e, t) {
  var n;
  return w(n = t('defaultShape' in e ? e.defaultShape : e.defaultState));
}

function x(e, t) {
  var n = {};

  for (var _r3 in t) {
    var _o = t[_r3],
        _a2 = n[_r3] = u(_r3);

    e.on(_a2, _o);
  }

  return n;
}

function j(e) {
  var t = {};

  for (var _n2 in e) {
    var _r4 = e[_n2];
    t[_n2] = Ie(_r4) ? _r4 : y({
      currentState: _r4,
      config: {
        name: _n2
      }
    });
  }

  return t;
}

function E(e, t) {
  var n = y({
    currentState: t,
    parent: e.domainName,
    config: {
      name: e.shortName
    }
  });
  return n.on(e.done, function (e, _ref9) {
    var t = _ref9.result;
    return t;
  }), n;
}

function I(e, t) {
  var n = y({
    currentState: t,
    parent: e.domainName,
    config: {
      name: e.shortName
    }
  });
  return n.on(e, function (e, t) {
    return t;
  }), n;
}

function q(e, t) {
  return Ie(e) ? e : qe(e) ? I(e, t) : Ce(e) ? E(e, t) : j(e);
}

function C(e, t) {
  return function (n) {
    return t(e.getState(), n);
  };
}

function O() {
  for (var _len3 = arguments.length, e = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    e[_key3] = arguments[_key3];
  }

  var t, n, r;
  z(e.length > 0, 'at least one argument required');
  {
    var _r5 = e[e.length - 1];
    'function' == typeof _r5 ? (n = e.slice(0, -1), t = _r5) : n = e;
  }

  e: {
    if (1 === n.length) {
      var _e3 = n[0];

      if (!Ie(_e3)) {
        r = _e3;
        break e;
      }
    }

    r = n, t && (t = Ke(t));
  }

  return w(r, t);
}

function D(e, t, n) {
  var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var o;
  void 0 === t && 'source' in e && (t = e.clock || e.sampler, n = e.fn, r = e.greedy, o = e.target, e = e.source), void 0 === t && (t = e);
  var a = Qe(e),
      i = Qe(t);
  return 'boolean' == typeof n && (r = n, n = void 0), (Ie(a) ? Ie(i) ? Je : _e : Le)(a, i, n, r, o);
}

function F() {
  var _this = this;

  var e = new Promise(function (e, t) {
    _this.rs = e, _this.rj = t;
  });
  e.anyway = function () {
    return xe(0, '.anyway is deprecated, use .finally'), e.then(function () {}, function () {});
  }, this.req = e;
}

function H(_ref10) {
  var e = _ref10.name,
      t = _ref10.parent,
      n = _ref10.config;
  var r = n.handler,
      o = s({
    name: e,
    parent: t,
    config: n
  }),
      a = o.create,
      i = s({
    name: o.shortName + ' done',
    parent: t,
    config: n
  }),
      c = s({
    name: o.shortName + ' fail',
    parent: t,
    config: n
  });
  i.graphite.seq.push(Xe), c.graphite.seq.push(Xe);

  var l = r || function () {
    return xe(0, 'no thunk used in %s', this.getType()), Promise.resolve();
  }.bind(o);

  o.done = i, o.fail = c, o.use = function (e) {
    return l = e, o;
  };

  var u = function u() {
    return l;
  };

  return o.use.getCurrent = u, o.kind = V, o.graphite.scope = {
    done: i,
    fail: c,
    getHandler: u
  }, o.graphite.seq.push(L.compute({
    fn: function fn(e) {
      return 'object' == typeof e && null !== e && 'ɔ' in e ? e.ɔ : {
        params: e,
        req: {
          rs: function rs(e) {},
          rj: function rj(e) {}
        }
      };
    }
  }), L.run({
    fn: function fn(_ref11, _ref12) {
      var e = _ref11.params,
          t = _ref11.req;
      var n = _ref12.getHandler,
          r = _ref12.done,
          o = _ref12.fail;
      return function (e, t, n, r) {
        var o,
            a,
            i = 0;

        try {
          a = e(t);
        } catch (e) {
          i = 1, o = e;
        }

        i ? r(o) : 'object' != typeof a || null === a || 'function' != typeof a.then ? n(a) : a.then(n, r);
      }(n(), e, function (e) {
        var t = this.event,
            n = this.params,
            r = this.handler;
        ve(t, {
          handler: r,
          toHandler: e,
          result: {
            params: n,
            result: e
          }
        });
      }.bind({
        event: r,
        params: e,
        handler: t.rs
      }), function (e) {
        var t = this.event,
            n = this.params,
            r = this.handler;
        ve(t, {
          handler: r,
          toHandler: e,
          result: {
            params: n,
            error: e
          }
        });
      }.bind({
        event: o,
        params: e,
        handler: t.rj
      })), e;
    }
  })), o.create = function (e, t, n) {
    var r = new F();
    return a({
      "ɔ": {
        params: e,
        req: r
      }
    }, o.getType(), n), r.req;
  }, o.pending = N(Boolean(0)).on(o, function () {
    return Boolean(1);
  }).reset(i).reset(c), o;
}

function M(e, t) {
  var _l2 = l(e, t),
      n = _l2.config,
      r = _l2.name;

  return H({
    name: r,
    domainName: '',
    config: n
  });
}

function R(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _l3 = l(e, t),
      n = _l3.config,
      r = _l3.name;

  return function e(_ref13) {
    var t = _ref13.name,
        _ref13$config = _ref13.config,
        n = _ref13$config === void 0 ? {} : _ref13$config,
        r = _ref13.parent,
        a = _ref13.parentHooks;

    var i = et(),
        l = o(t || '', r),
        u = new Ye(),
        f = function (e, t, n) {
      var r;
      return (r = n ? $e(n) : Ze(t)).domain.watch(function (t) {
        e.domains.add(t);
      }), r.event.watch(function (t) {
        e.events.add(t);
      }), r.store.watch(function (t) {
        e.storages.add(t);
      }), r.effect.watch(function (t) {
        e.effects.add(t);
      }), r;
    }(u, l, a);

    return {
      compositeName: l,
      id: i,
      defaultConfig: n,
      getType: function getType() {
        return l.fullName;
      },
      onCreateEvent: function onCreateEvent(e) {
        return u.events.forEach(e), f.event.watch(e);
      },
      onCreateEffect: function onCreateEffect(e) {
        return u.effects.forEach(e), f.effect.watch(e);
      },
      onCreateStore: function onCreateStore(e) {
        return u.storages.forEach(e), f.store.watch(e);
      },
      onCreateDomain: function onCreateDomain(e) {
        return u.domains.forEach(e), f.domain.watch(e);
      },
      event: function event(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var n = c(t),
            r = s({
          name: e,
          parent: l,
          config: n
        });
        return f.event(r), r;
      },
      effect: function effect(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var n = c(t),
            r = H({
          name: e,
          domainName: l.fullName,
          parent: l,
          config: n
        });
        return f.effect(r), r;
      },
      domain: function domain(t) {
        var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var r = c(n),
            o = e({
          name: t,
          parent: l,
          parentHooks: f,
          config: r
        });
        return f.domain(o), o;
      },
      store: function store(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var n = c(t),
            r = y({
          currentState: e,
          parent: l,
          config: n
        });
        return f.store(r), r;
      },
      kind: W
    };
  }({
    name: void 0 === r ? '' : r,
    config: n
  });
}

import T from 'symbol-observable';
var B = "0.18.11",
    G = 'production' !== process.env.NODE_ENV;
var z = G ? function e(t, n) {
  for (var _len4 = arguments.length, r = new Array(_len4 > 2 ? _len4 - 2 : 0), _key4 = 2; _key4 < _len4; _key4++) {
    r[_key4 - 2] = arguments[_key4];
  }

  if (!t) {
    var _t2 = Error();

    Error.captureStackTrace && Error.captureStackTrace(_t2, e), _t2.name = 'Invariant Violation';
    var _o2 = 0;
    throw _t2.message = n.replace(/%s/g, function () {
      return r[_o2++];
    }), _t2;
  }
} : function (e) {
  if (!e) throw Error('Minified exception occurred');
};
var A = 'store',
    P = 'event',
    V = 'effect',
    W = 'domain';
var K = Object.freeze({
  store: A,
  event: P,
  effect: V,
  domain: W
});

var U = function U() {
  var e = 0;
  return function () {
    return (++e).toString(36);
  };
},
    _ = U(),
    J = function J(e, t) {
  return {
    id: _(),
    type: e,
    group: 'cmd',
    data: t
  };
},
    L = {
  barrier: function barrier(_ref14) {
    var e = _ref14.barrierID,
        _ref14$priority = _ref14.priority,
        t = _ref14$priority === void 0 ? "barrier" : _ref14$priority;
    return J('barrier', {
      barrierID: e,
      priority: t
    });
  },
  compute: J.bind(null, 'compute'),
  emit: J.bind(null, 'emit'),
  filter: J.bind(null, 'filter'),
  run: J.bind(null, 'run'),
  tap: J.bind(null, 'tap'),
  update: J.bind(null, 'update')
},
    Q = function Q(e) {
  var _ref15 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      t = _ref15.deep;

  var n = X(e);
  t && n.next.forEach(function (e) {
    return Q(e, {
      deep: t
    });
  }), n.from.forEach(function (e) {
    var t = e.next.indexOf(n);
    -1 !== t && e.next.splice(t, 1);
  }), n.from.length = 0, n.next.length = 0, n.seq.length = 0, n.scope = null;
},
    X = function X(e) {
  return e.graphite || e;
},
    Y = U(),
    Z = function Z(e) {
  return {
    id: Y(),
    current: e
  };
},
    $ = function $(_ref16) {
  var e = _ref16.current;
  return e;
},
    ee = function ee(e, t) {
  return e.current = t;
},
    te = U(),
    ne = function ne(e) {
  switch (e) {
    case 'child':
      return 0;

    case 'pure':
      return 1;

    case 'barrier':
      return 2;

    case 'sampler':
      return 3;

    case 'effect':
      return 4;

    default:
      return -1;
  }
};

var re = function re(e, t) {
  _classCallCheck(this, re);

  this.value = {
    current: e
  }, this.parent = t;
};

var oe = function oe(e, t, n, r) {
  _classCallCheck(this, oe);

  this.value = e, this.rank = t, this.left = n, this.right = r;
};

var ae = function ae(e) {
  return e ? ie(e.left, e.right) : null;
},
    ie = function ie(e, t) {
  var n, r, o, a, i, s, c;

  for (;;) {
    var l, u;
    if (n = t, !(r = e)) return n;
    if (!n) return r;
    if (a = r.left, !ce(o = r.value, n.value)) return i = ie(r.right, n), (s = (null === (l = a) || void 0 === l ? void 0 : l.rank) || 0) >= (c = (null === (u = i) || void 0 === u ? void 0 : u.rank) || 0) ? new oe(o, c + 1, a, i) : new oe(o, s + 1, i, a);
    t = r, e = n;
  }
};

var se = function se(e) {
  _classCallCheck(this, se);

  this.isChanged = 1, this.isFailed = 0, this.scope = e;
};

var ce = function ce(e, t) {
  return e.type === t.type ? e.id > t.id : ne(e.type) > ne(t.type);
};

var le = 0,
    ue = null;

var fe = new Set(),
    de = function de(e) {
  ue = function (e, t) {
    return ie(new oe(e, 1, null, null), t);
  }(e, ue);
},
    pe = function pe(_ref17, o) {
  var e = _ref17.step,
      t = _ref17.firstIndex,
      n = _ref17.scope,
      r = _ref17.resetStop;
  var a = new se(e.scope);

  for (var _r6 = t; _r6 < e.seq.length && !o.stop; _r6++) {
    var _i3 = e.seq[_r6];
    if (_r6 === t) 'barrier' === _i3.type && fe.delete(_i3.data.barrierID);else switch (_i3.type) {
      case 'run':
        return void de({
          step: e,
          firstIndex: _r6,
          scope: n,
          resetStop: 0,
          type: 'effect',
          id: ++le
        });

      case 'barrier':
        {
          var _t3 = _i3.data.barrierID;
          return void (fe.has(_t3) || (fe.add(_t3), de({
            step: e,
            firstIndex: _r6,
            scope: n,
            resetStop: 0,
            type: _i3.data.priority,
            id: ++le
          })));
        }
    }
    (0, ye[_i3.type])(a, _i3.data, n.value), o.stop = a.isFailed || !a.isChanged;
  }

  if (!o.stop) for (var _t4 = 0; _t4 < e.next.length; _t4++) {
    var _r7 = new re($(n.value), n);

    de({
      step: e.next[_t4],
      firstIndex: 0,
      scope: _r7,
      resetStop: 1,
      type: 'child',
      id: ++le
    });
  }
  r && (o.stop = 0);
};

var me = 0;

var he = function he(e, t) {
  de({
    step: X(e),
    firstIndex: 0,
    scope: new re(t, null),
    resetStop: 0,
    type: 'pure',
    id: ++le
  });
},
    be = function be() {
  var e = me;
  me = 1;
  var t = {
    stop: 0
  };
  var n;

  for (; ue;) {
    n = ue.value, ue = ae(ue), pe(n, t);
  }

  me = e;
},
    ge = function ge(e, t) {
  he(e, t), be();
},
    ve = function ve(e, t) {
  he(e, t), me || be();
},
    ye = {
  barrier: function barrier(e, t, n) {
    e.isFailed = 0, e.isChanged = 1;
  },
  emit: function emit(e, t, n) {},
  filter: function filter(e, t, n) {
    var r = Ne({
      arg: $(n),
      val: e.scope,
      fn: t.fn
    });
    e.isChanged = !!r.result;
  },
  run: function run(e, t, n) {
    var r = Ne({
      arg: $(n),
      val: e.scope,
      fn: t.fn
    });
    e.isFailed = r.err, ee(n, r.result);
  },
  update: function update(e, t, n) {
    ee(t.store, $(n));
  },
  compute: function compute(e, t, n) {
    var r = Ne({
      arg: $(n),
      val: e.scope,
      fn: t.fn
    });
    e.isFailed = r.err, ee(n, r.result);
  },
  tap: function tap(e, t, n) {
    var r = Ne({
      arg: $(n),
      val: e.scope,
      fn: t.fn
    });
    e.isFailed = r.err;
  }
},
    Ne = function Ne(_ref18) {
  var e = _ref18.fn,
      t = _ref18.arg,
      n = _ref18.val;
  var r = {
    err: 0,
    result: null
  };

  try {
    r.result = e(t, n);
  } catch (e) {
    console.error(e), r.err = 1;
  }

  return r;
},
    Se = L.filter({
  fn: function fn(e, _ref19) {
    var t = _ref19.state;
    return e !== $(t) && void 0 !== e;
  }
}),
    we = L.compute({
  fn: function fn(e) {
    return e;
  }
});

var ke = Object.freeze({
  filterChanged: Se,
  noop: we
}),
    xe = G ? function (e, t) {
  var _console;

  for (var _len5 = arguments.length, n = new Array(_len5 > 2 ? _len5 - 2 : 0), _key5 = 2; _key5 < _len5; _key5++) {
    n[_key5 - 2] = arguments[_key5];
  }

  e || (_console = console).error.apply(_console, ['Warning: ' + t].concat(n));
} : function () {};

var je = function je(e) {
  return ('function' == typeof e || 'object' == typeof e && null !== e) && 'kind' in e;
},
    Ee = function Ee(e) {
  return function (t) {
    return je(t) && t.kind === e;
  };
},
    Ie = Ee(A),
    qe = Ee(P),
    Ce = Ee(V),
    Oe = Ee(W);

var De = Object.freeze({
  unit: je,
  store: Ie,
  event: qe,
  effect: Ce,
  domain: Oe
});

var Fe = 25,
    He = function He() {
  return -1;
},
    Me = function Me() {
  return [];
},
    Re = function Re(t, n) {
  return Te({
    from: t,
    to: e(n)
  });
},
    Te = function Te(e) {
  var t = X(e.from),
      n = X(e.to);
  return t.next.push(n), function (e) {
    var t = e.parent.next,
        n = {
      indexOf: t.indexOf.bind(t, e.child),
      splice: t.splice.bind(t)
    },
        r = i.bind(n);
    return r.unsubscribe = i.bind(n), r;
  }({
    child: n,
    parent: t
  });
},
    Be = U();

var Ge = null,
    ze = null;

if (G) {
  var Ae = function Ae(t) {
    return _e4 + " " + t;
  };

  var Pe = function Pe(e, t) {
    return e + "." + t;
  };

  var Ve = function Ve(e, t) {
    return e + " (#" + t + ")";
  };

  var _e4 = '☄',
      _n3 = 'undefined' != typeof performance && 'function' == typeof performance.mark && 'function' == typeof performance.clearMarks && 'function' == typeof performance.measure && 'function' == typeof performance.clearMeasures;

  var _r8 = function _r8(t, n) {
    return _e4 + " " + t + (n ? " Warning: " + n : '');
  };

  var _o3 = function _o3() {
    null !== Ge && null !== ze && function (e, n) {
      var r = t(e),
          o = e.id;
      var a;
      a = Ve(Pe(r, n), o), performance.clearMarks(Ae(a));
    }(ze, Ge), ze = null, Ge = null;
  };

  d = function d(e, r) {
    _n3 && (_o3(), function (e, n) {
      var r = t(e),
          o = e.id;
      return a = Ve(Pe(r, n), o), performance.mark(Ae(a)), 1;
      var a;
    }(e, r) && (ze = e, Ge = r));
  }, p = function p(e) {
    _n3 && (null !== Ge && null !== ze && function (e, n, o) {
      var a = t(e),
          i = e.id,
          s = Pe(a, n);

      (function (e, t, n) {
        var o = Ae(t),
            a = _r8(e, n);

        try {
          performance.measure(a, o);
        } catch (e) {}

        performance.clearMarks(o), performance.clearMeasures(a);
      })(s, Ve(s, i), o);
    }(ze, Ge, e), Ge = null, ze = null);
  };
}

var We = function We(e, t, r) {
  var o = [L.filter({
    fn: function fn(e, _ref20) {
      var t = _ref20.target,
          n = _ref20.key;
      return e !== $(t)[n] && void 0 !== e;
    }
  }), L.tap({
    fn: function fn(e, _ref21) {
      var t = _ref21.isFresh,
          n = _ref21.target,
          r = _ref21.clone;
      $(t) || (ee(n, r($(n))), ee(t, 1));
    }
  }), L.tap({
    fn: function fn(e, _ref22) {
      var t = _ref22.target,
          n = _ref22.key;
      $(t)[n] = e;
    }
  }), L.barrier({
    barrierID: te()
  }), L.compute({
    fn: function fn(e, _ref23) {
      var t = _ref23.isFresh,
          n = _ref23.target;
      return ee(t, 0), $(n);
    }
  })],
      a = t(r),
      i = y({
    currentState: a,
    config: {
      name: n(e)
    }
  }),
      s = Z(0);

  for (var _n4 in e) {
    var _c = e[_n4];
    Ie(_c) ? (r[_n4] = _c.defaultState, a[_n4] = _c.getState(), Re(_c, {
      scope: {
        key: _n4,
        clone: t,
        target: i.stateRef,
        isFresh: s
      },
      node: o,
      child: [i]
    })) : a[_n4] = r[_n4] = _c;
  }

  return i.defaultShape = e, i.defaultState = r, i;
},
    Ke = function Ke(e) {
  return function (t) {
    return e.apply(void 0, _toConsumableArray(t));
  };
},
    Ue = function Ue(e, t, n, r, o) {
  return Re(t, {
    scope: {
      state: e.stateRef,
      fn: n
    },
    child: [o],
    node: [!r && we, !r && L.barrier({
      barrierID: te(),
      priority: 'sampler'
    }), L.compute({
      fn: n ? function (e, _ref24) {
        var t = _ref24.state,
            n = _ref24.fn;
        return n($(t), e);
      } : function (e, _ref25) {
        var t = _ref25.state;
        return $(t);
      }
    })].filter(Boolean)
  }), o;
},
    _e = function _e(e, t, n, r, o) {
  return Ue(e, t, n, r, o || s({
    name: e.shortName,
    parent: e.domainName
  }));
},
    Je = function Je(e, t, n, r, o) {
  var a = $(e.stateRef);
  return Ue(e, t, n, r, o || y({
    currentState: n ? n(a, $(t.stateRef)) : a,
    config: {
      name: e.shortName
    },
    parent: e.domainName
  }));
},
    Le = function Le(e, t, n, r, o) {
  o = o || s({
    name: e.shortName,
    parent: e.domainName
  });
  var a = Z(0),
      i = Z(),
      c = Z();
  return Re(e, {
    scope: {
      hasSource: a
    },
    node: [L.update({
      store: i
    }), L.tap({
      fn: function fn(e, _ref26) {
        var t = _ref26.hasSource;
        ee(t, 1);
      }
    })]
  }), Re(t, {
    scope: {
      sourceState: i,
      clockState: c,
      hasSource: a,
      fn: n
    },
    child: [o],
    node: [L.update({
      store: c
    }), L.filter({
      fn: function fn(e, _ref27) {
        var t = _ref27.hasSource;
        return $(t);
      }
    }), !r && L.barrier({
      barrierID: te(),
      priority: 'sampler'
    }), L.compute({
      fn: n ? function (e, _ref28) {
        var t = _ref28.sourceState,
            n = _ref28.clockState,
            r = _ref28.fn;
        return r($(t), $(n));
      } : function (e, _ref29) {
        var t = _ref29.sourceState;
        return $(t);
      }
    })].filter(Boolean)
  }), o;
},
    Qe = function Qe(e) {
  return je(e) ? e : w(e);
},
    Xe = L.run({
  fn: function fn(_ref30) {
    var e = _ref30.handler,
        t = _ref30.toHandler,
        n = _ref30.result;
    return e(t), n;
  }
});

var Ye = function Ye() {
  _classCallCheck(this, Ye);

  this.events = new Set(), this.effects = new Set(), this.storages = new Set(), this.domains = new Set();
};

var Ze = function Ze(e) {
  return {
    event: s({
      name: e.fullName + " event hook",
      parent: e
    }),
    effect: s({
      name: e.fullName + " effect hook",
      parent: e
    }),
    store: s({
      name: e.fullName + " store hook",
      parent: e
    }),
    domain: s({
      parent: e
    })
  };
},
    $e = function $e(e) {
  return {
    event: e.event.prepend(function (e) {
      return e;
    }),
    effect: e.effect.prepend(function (e) {
      return e;
    }),
    store: e.store.prepend(function (e) {
      return e;
    }),
    domain: e.domain.prepend(function (e) {
      return e;
    })
  };
},
    et = U();

export { K as Kind, ke as blocks, Q as clearNode, O as combine, x as createApi, R as createDomain, M as createEffect, u as createEvent, e as createNode, N as createStore, O as createStoreObject, k as extract, Te as forward, f as fromObservable, z as invariant, De as is, Oe as isDomain, Ce as isEffect, qe as isEvent, Ie as isStore, je as isUnit, ge as launch, q as restore, E as restoreEffect, I as restoreEvent, j as restoreObject, D as sample, S as setStoreName, L as step, B as version, xe as warning, C as withProps };